export const ADMIN_CLIENT_ORIGIN = "RedoTech-AdminClient";
export const API_CLIENT_ORIGIN = "RedoTech-ApiClient";
export const MERCHANT_APP_ORIGIN = "RedoTech-MerchantApp";
export const MERCHANT_MOBILE_ORIGIN = "RedoTech-MerchantMobile";
